import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { DEFAULT_PAGE } from 'app/common/constants';

@Injectable({
  providedIn: 'root'
})
export class MainGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    if (localStorage.getItem('tryLogin')) {
      let role = parseInt(localStorage.getItem('role'));
      if (role < 8) {
        this.router.navigateByUrl('/' + DEFAULT_PAGE);
      }
      return false;
    } else {
      return true;
    }
  }
}